import router from '../router'
import { DuelSfx } from '../game/audio/DuelSfx'
import { armDuelLandscape } from '../composables/useDuelOrientation'
import { usePlayerStore } from '../stores/player'

let navigating = false

export type TournamentEntryVia = 'dialog' | 'bracket' | 'notice' | 'advance'

/** Opens the duel page so the server can seat this account. */
export async function openTournamentMatch(
  matchId: string,
  via?: TournamentEntryVia,
): Promise<void> {
  if (navigating || !matchId) return
  const route = router.currentRoute.value
  if (route.name === 'online-duel' && String(route.query.match || '') === matchId) return
  navigating = true
  try {
    DuelSfx.prime()
    armDuelLandscape()
    await router.push({
      name: 'online-duel',
      query: {
        mode: 'tournament',
        match: matchId,
        username: usePlayerStore().username,
        ...(via ? { entry: via } : {}),
      },
    })
  } finally {
    navigating = false
  }
}

export function openSpectate(code: string): void {
  DuelSfx.prime()
  void router.push({
    name: 'online-duel',
    query: { mode: 'spectate', code, from: 'tournament' },
  })
}
